import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpEvent, HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomHttpParams } from '../api-handler/api-handler.service';
import { Guid } from 'guid-typescript';
import { AppState } from '../../../store/state.model';
import { NgRedux } from '@angular-redux/store';



/** This method intercepts the http request and set the headers required by Account management*/
@Injectable()
export class NaviHeaderInterceptorService implements HttpInterceptor {
  /**
  * has a dependency on domain matcher to generate a dynamic X-channel
  * DomainMatcher
  **/
  constructor(public ngRedux: NgRedux<AppState>) { }

  /**
  * @event intercept Intercept any request that is triggered by APIHandler and sets the common header of the ORCH layer
  * @args domainMatcher
  * @returns The response that is being intercepted so it can continue to the Network call
  **/
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = {};
    if (req.params instanceof CustomHttpParams && req.params.spec) {
      switch (req.params.spec) {
        case 'navi':
          headers = this.getPortalHeaders(req.params.spec);
          break;
      }
    }
    return next.handle(req.clone({
      setHeaders: headers
    }));
  }
  /**
  * getPortalHeaders Return the common headers on the request
  **/
  public getPortalHeaders(type): object {
    let obj = {
      'x-correlationid': Guid.create().toString(),
      'X-CHANNEL': 'OP_ADMIN'
    };
    obj = (type === 'navi') ? obj : Object.assign(obj, { 'X-BRAND': 'T' });
    return obj;
  }
}
